var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconReceipt = function SvgIconReceipt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon_receipt_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.999 4.5c0-.276.229-.499.506-.499h9.5c.542 0 1 .447 1 1v10h-3.613c-.578 0-1.048.47-1.048 1.049v.602A3.344 3.344 0 0 1 6.997 20a3.003 3.003 0 0 1-2.998-3V4.5M2 14V4.5C2 3.12 3.12 2 4.505 2h9.5a3.003 3.003 0 0 1 2.998 3.001v10h3.938c.59 0 1.059.47 1.059 1.049 0 3.3-2.733 5.95-5.996 5.95H6.997a4.99 4.99 0 0 1-4.985-4.885H2V14m14.004 6h-4.829a5.35 5.35 0 0 0 1.156-3h7.55c-.434 1.716-2.023 3-3.877 3m-9.007-9c-.542 0-1 .448-1 1s.458 1 1 1h5.01c.541 0 .998-.448.998-1s-.457-1-.999-1zm-1-3c0-.552.458-1 1-1h5.01c.541 0 .998.448.998 1 0 .553-.457 1-.999 1h-5.01c-.54 0-.998-.447-.998-1",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_receipt_svg__a",
    width: 24,
    height: 26,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export default SvgIconReceipt;